import {
  PiArrowBendUpLeft,
  PiArrowBendDoubleUpLeft,
  PiArrowBendUpRight,
} from 'react-icons/pi'
import { ComposeMode } from './ComposePanel'

const REPLY_BUTTON_CLASS =
  'flex items-center gap-2 px-4 h-9 rounded border border-line text-sm font-medium tracking-[-0.14px] text-fg hover:bg-surface-alt active:bg-surface-alt-active transition-colors disabled:opacity-50 disabled:cursor-not-allowed'

interface EmailReplyBarProps {
  onCompose?: (mode: ComposeMode) => void
}

/** Bottom bar with Reply, Reply all, and Forward buttons. */
export function EmailReplyBar({ onCompose }: EmailReplyBarProps) {
  return (
    <div className="flex items-center gap-3 pt-4 border-t border-line-subtle">
      <button
        type="button"
        disabled={!onCompose}
        onClick={() => onCompose?.('reply')}
        className={REPLY_BUTTON_CLASS}
      >
        <PiArrowBendUpLeft className="size-5" />
        Reply
      </button>
      <button
        type="button"
        disabled={!onCompose}
        onClick={() => onCompose?.('reply_all')}
        className={REPLY_BUTTON_CLASS}
      >
        <PiArrowBendDoubleUpLeft className="size-5" />
        Reply all
      </button>
      <button
        type="button"
        disabled={!onCompose}
        onClick={() => onCompose?.('forward')}
        className={REPLY_BUTTON_CLASS}
      >
        <PiArrowBendUpRight className="size-5" />
        Forward
      </button>
    </div>
  )
}
